import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import StatRow from './stat-row';

export default withLDConsumer()(StatRow);
